export const Z_INDEX = {
  BACK_DROP: 10,
  RANKING_LIST: 20,
  STICKY_HEADER: 30,
  /** グロナビのZ_INDEX */
  HEADER: 51,
  PLAYER_TOP_CONTROLLER: 55,
  PLAYER_CAROUSEL_MODAL: 60,
  PLAYER_BOTTOM_CONTROLLER: 70,
  PLAYER_SWITCH_DISPLAY: 70,
  PLAYER_NEXT_EPISODE: 70,
  PLAYER_TOP_CONTROLLER_HAS_VISIBLE_POPUP: 75,
  PLAYER_SEEK_THUMBNAIL: 80,
  PLAYER_N_SKIP_ANIMATION: 85,
  PLAYER_BOTTOM_POPUP: 90,
  MINI_DETAIL: 90,
  MODAL: 100,
  LOADING_OVERLAY: 130,
  TOOLTIP: 160,
  MODAL_IN_MODAL: 200,
  DIALOG: 210,
  TOAST: 220,
} as const;
